import { useIsMutating } from '@tanstack/react-query'

import { Button } from '@/components/ui/button'
import {
  POLICY_CHANGE_WRITE_KEY,
  type PolicyChangeKind,
  type PolicyChangeRequest,
} from '@/models/policyChange'
import { ClaimStepShell } from '../Claims/ClaimStepShell'
import { ChangeCards } from './ChangeCards'

interface StepDetailsProps {
  orgId: string
  request: PolicyChangeRequest
  kinds: PolicyChangeKind[]
  onBack: () => void
  onNext: () => void
}

/** The form's second step: each change, by kind. */
export function StepDetails({ orgId, request, kinds, onBack, onNext }: StepDetailsProps) {
  // Leaving mid-save would sign a request without the change, or with one just taken out.
  const saving = useIsMutating({ mutationKey: POLICY_CHANGE_WRITE_KEY }) > 0

  return (
    <ClaimStepShell
      step={2}
      stepCount={4}
      title="Details"
      subtitle="Add each change. You can add more than one of a kind."
    >
      <ChangeCards orgId={orgId} request={request} kinds={kinds} />
      <div className="flex justify-between">
        <Button type="button" variant="outline" disabled={saving} onClick={onBack}>
          ← Back
        </Button>
        <Button
          type="button"
          // The save in flight shows on its own button; this one only waits for it.
          disabled={saving || !request.changes.some((line) => !line.dropped)}
          onClick={onNext}
        >
          Next →
        </Button>
      </div>
    </ClaimStepShell>
  )
}
